import axios from 'axios';

import { injectAccessTokenInterceptor, refreshTokenResponseInterceptor }
  from '~/services/keycloack-api/keycloack-api.interceptors';

const http = axios.create({
  baseURL: import.meta.env.VITE_RECEIPT_MODEL_URL,
});

http.interceptors.request.use(injectAccessTokenInterceptor);
http.interceptors.response.use((c) => c, refreshTokenResponseInterceptor);

export default http;
